<template>

    <modal-container>

        <template>
            
            <component :is="faqComponent" @changeContent="update($event)" v-bind="faqParams"></component>

        </template>

    </modal-container>

</template>

<script>
    const FaqList = Vue.component('container_faq_list', require('../../modals/faq/_list.vue').default);
    const FaqDetails = Vue.component('container_faq_details', require('../../modals/faq/_details.vue').default);

    export default {

        data: function () {
            return {
                faqComponent: FaqList,
                faqParams: null,
            }
        },

        methods: {

            update($event) {
                this.faqParams = $event

                var currComponent

                if ($event.page == 'details')
                    currComponent = FaqDetails
                else
                    currComponent = FaqList
                
                this.faqComponent = currComponent
            },

        },
    }
</script>
